import { DOCUMENT } from '@angular/common';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthModule } from '@auth0/auth0-angular';
import { DomianProviderService } from '../lib/services/domain-provider.service';
import { envs } from '../lib/data/env.data';
import { Banner, BANNER_CONFIG } from '../lib/data/banner.data';
import { getBannerFromUrl } from '../lib/services/appconfig.service';

@Component({
  standalone: true,
  imports: [RouterModule, AuthModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private document: HTMLDocument = inject(DOCUMENT);
  private bannerService: DomianProviderService = inject(DomianProviderService);
  readonly banner = signal<Banner>(Banner.SHOPRITE);

  title = computed(
    () => 'Social Offer - ' + BANNER_CONFIG[this.banner()].title
  );
  ngOnInit(): void {
    this.banner.set(
      envs.useParamsForBanner
        ? getBannerFromUrl() || Banner.SHOPRITE
        : this.bannerService.getBanner()
    );
    this.setFavicon();
    this.setTitle();
  }
  /**
   * Sets the website favicon to the provided image URL.
   * @param imageUrl The URL of the image to use as favicon.
   */
  setFavicon(): void {
    const link: HTMLLinkElement = this.document.querySelector(
      '#appFavicon'
    ) as HTMLLinkElement;
    if (link) {
      link.href =
        BANNER_CONFIG[this.banner()].faviconUrl || 'shoprite/favicon.ico';
    }
  }

  setTitle(): void {
    const title: HTMLTitleElement = this.document.querySelector(
      '#appTitle'
    ) as HTMLTitleElement;
    if (title) {
      title.textContent =
        'Social Offer - ' + BANNER_CONFIG[this.banner()].title;
    }
  }
}
